import { Fragment, useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setFormValue } from "../../redux/slices/migrationspageslice";
import { setCurrentPageIsDirty } from "../../redux/slices/currentpageslice";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput, FormCheckbox, FormDropDownList, FormTextArea, FormDropDownListById} from "../../forms/form-components";
import { DropDownButton } from "@progress/kendo-react-buttons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { FormRegion } from "../../components/formregion";
import { formValidator } from "./migrationspageformvalidator";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { MyGrid } from "../../components/mygrid";

import i18next from "i18next";
import { useTranslation } from "react-i18next";


export const MigrationsPageForm = props => {
  const dispatch = useDispatch();
  const currentTheme = useSelector(state => state.currentTheme);
  const pageState = useSelector(state => state.migrationsPage);
  const currentPlan = useSelector(state => state.migrationsPage.currentPlan);
  const updateDirtyState = props.updateDirtyState;
  const getStatusText = props.getStatusText;

  const currentMigration = pageState.formValues;

  const { t } = useTranslation();

  //statusText
  let statusText = "";
  if (pageState.formValues)
      statusText = getStatusText(pageState.formValues.Status);


  //entities
  const alertsList = pageState.lookups.entities.filter(e => e.EntityTypeId == 1);
  const reportsList = pageState.lookups.entities.filter(e => e.EntityTypeId == 2);


  //handle is dirty
  useEffect(()=>{
       updateDirtyState();
  }, [pageState.formInitialValues, pageState.formValues])


  return (
    <Fragment>
        <Form    
            validator={formValidator} 
            key={pageState.formKey}
            initialValues={{...pageState.formInitialValues}}
            render={(formRenderProps) => {
                return (
                    <FormElement horizontal={false}
                            style={{
                                // width: 250,
                            }}
                    >                        
                        <FormRegion className="form-region-1">                        
                            <div className="form-group form-group-1">
                                <div className="form-row">
                                    <div style={{flex: 1, marginRight: 30}}>
                                        <Field 
                                            id={"Name"}
                                            name={"Name"}
                                            label={t("migrations.name")}
                                            component={FormInput}
                                            onChange={ e => {
                                                dispatch(setFormValue({id: "Name", value:e.value}))
                                            }}
                                            autoFocus={true}
                                            disabled={pageState.isProcessing}
                                            maxLength={100} 
                                        />
                                    </div>
                                    <div style={{fontSize: 13, display: "flex", alignItems: "center", justifyContent: "flex-start", flex: 1, marginLeft: 30}}>
                                    {
                                        pageState.mode == 2 &&
                                        <>
                                            <div style={{width: 130}}>
                                                <div style={{width: 70}}>{t("migrations.version")}</div>
                                                <div style={{width: 70, marginLeft: 18, marginTop:12, color: currentTheme.info}}>{pageState.formValues.Version}</div>
                                            </div>
                                            <div style={{width: 100}}>
                                                <div style={{}}>{t("migrations.active")}</div>
                                                <div style={{marginTop: 12, color: currentTheme.info}}>{pageState.formValues.IsActive ? "True" : "False"}</div>
                                            </div>
                                            <div>
                                                <div style={{}}>{t("migrations.status")}</div>
                                                <div style={{marginTop: 12, color: pageState.Status == -1 ? currentTheme.error : (pageState.Status == 0 ? currentTheme.warning : currentTheme.success)}}>{statusText}</div>
                                            </div>     
                                        </>                                   
                                    }
                                    </div>
                                </div>
                                <div className="form-row" style={{marginTop: 18}}>
                                    <div style={{flex: 1, marginRight: 30}}>
                                        <Field                                    
                                            id={"Description"}
                                            name={"Description"}
                                            label={t("migrations.description")}
                                            component={FormTextArea}
                                            style={{height:50}}
                                            onChange={ e => dispatch(setFormValue({id: "Description", value:e.value}))}
                                            disabled={pageState.isProcessing}
                                            maxLength={900} 
                                        />                   
                                    </div>
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "flex-start", flex: 1, marginLeft: 30}}>    
                                        <Field 
                                            id={"BasicSchemaChanged"} 
                                            name="BasicSchemaChanged" 
                                            label={t("migrations.schema")}
                                            component={FormCheckbox}
                                            disabled={pageState.isProcessing || !currentMigration || currentMigration.Status != null}
                                            onChange={ e => dispatch(setFormValue({id: "BasicSchemaChanged", value:e.target.value}))}
                                        />                                    
                                    </div>
                                </div>
                                <div className="form-row" style={{marginTop: 22}}>
                                    <div style={{flex: 1, marginRight: 30}}>
                                        <div style={{fontSize:13, marginBottom: 4}}>
                                           {t("migrations.alerts")}
                                        </div>
                                        <MultiSelect disabled={pageState.isProcessing || !currentMigration || currentMigration.Status != null}
                                            data={alertsList} dataItemKey="EntityId" textField="EntityTitle"
                                            value={pageState.formValues.Entities.filter(e => e.EntityTypeId == 1)}
                                            onChange={props.onAlertCheck}
                                            style={{
                                                width: "100%",
                                            }}
                                            placeholder={t("migrations.select1")}
                                        />            
                                    </div>
                                    <div style={{flex: 1, marginLeft: 30}}> 
                                        <div style={{fontSize:13, marginBottom: 4}}>
                                            {t("migrations.reports")}
                                        </div>
                                        <MultiSelect disabled={pageState.isProcessing || !currentMigration || currentMigration.Status != null}
                                            data={reportsList} dataItemKey="EntityId" textField="EntityTitle"
                                            value={pageState.formValues.Entities.filter(e => e.EntityTypeId == 2)}
                                            onChange={props.onReportCheck}
                                            style={{
                                                width: "100%",
                                            }}
                                            placeholder={t("migrations.select1")}
                                        />                                       
                                    </div>
                                </div>          

                                <div style={{marginTop: 22, marginBottom: 20, width: "100%", height: 1, borderTop: "1.5px solid " + currentTheme.componentBorderColor}}>                                    
                                </div>         
                            </div>
                            <div className="form-details" style={{flex:1, width: "100%", minHeight: 400}}>
                            <TabStrip selected={pageState.formValues.TabIndex} onSelect={e => dispatch(setFormValue({id: "TabIndex", value: e.selected}))} >
                                <TabStripTab title={t("migrations.sub")}>
                                    <MyGrid className="migration-subscriptions-grid" currentTheme={currentTheme} 
                                        schema={pageState.formValues.Subscriptions.schema} data={pageState.formValues.Subscriptions.data} 
                                        rowStyleHandler={row =>{
                                            if (row.statusText.toLowerCase() == "failure")
                                                return {color: currentTheme.error};
                                            else
                                                return {color: currentTheme.success};
                                        }}
                                        isPageable={true} pageSize={100}
                                        isFilterable={false} isSortable={true}
                                    />
                                </TabStripTab>
                                <TabStripTab title={t("migrations.history")}>
                                    <MyGrid className="migration-history-grid" currentTheme={currentTheme} 
                                        schema={pageState.formValues.History.schema} data={pageState.formValues.History.data}
                                        rowStyleHandler={row =>{
                                            if (row.statusText.toLowerCase() == "failure")
                                                return {color: currentTheme.error};
                                            else
                                                return {color: currentTheme.success};
                                        }} 
                                        isPageable={true} pageSize={100}
                                        isFilterable={false} isSortable={true}
                                    />
                                </TabStripTab>
                            </TabStrip>
                            </div>
                        </FormRegion>
                    </FormElement>                
            )}}
        />    
        <style>
            {
                `        
                    .migrations-page-form .k-form
                    {          
                        /*the kendo form which is child of my form.content*/     
                        width: 100%;
                        display: flex;
                        flex: 1;
                        justify-content: space-between;
                        padding: 0 24px 12px 24px;/*keep 12px in right and bottom so that when minimizing we keep a white region to the right and bottom; also keep 8px on the left*/
                    }

                    .migrations-page-form .form-region-1
                    {
                        width: 100%;
                        max-width: 1300px;
                        padding-top: 20px !important;/*to override kendo first child of k-form having marginTop=0*/      
                        height: 100%;               
                    }

                    .migrations-page-form .form-region-1 .form-group-1
                    {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }

                    .migrations-page-form .form-row
                    {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                    }

                   
                    .migrations-page-form .form-region-root > .content
                    {
                        padding: 0px;
                        background-color: transparent;
                        align-items: flex-start;
                        height: 100%;
                    }

                    .migrations-page-form .form-region-root
                    {
                        background-color: transparent;
                        height: calc(100% - 4px);
                    }
                    
                    .migrations-page-form .form-region-root .k-form-field:nth-child(2)
                    {
                        margin-top: 18px !important;
                    }

                    .migrations-page-form .form-region-root .k-form-field:nth-child(7)
                    {
                        margin-top: -2px !important;
                    }

                    .migrations-page-form input.k-input, .migrations-page-form textarea.k-textarea, 
                    .migrations-page-form .k-dropdownlist .k-input-inner
                    {
                        /*make input controls have a bit more height*/
                        padding: 6px 8px;
                    } 

                    .migrations-page-form .k-form-field textarea
                    {
                        height: 200px !important;
                    }



                    .migrations-page-form .k-tabstrip
                    {
                        height: 100%;
                        width: 100%;
                    }

                    .migrations-page-form .k-tabstrip .k-content .k-animation-container
                    {
                        width: 100%;
                        height: calc(100% - 4px);
                    }

                    .migrations-page-form .k-tabstrip .k-content .k-animation-container .k-child-animation-container
                    {
                        height: 100%;
                    }
                    .migrations-page-form .k-tabstrip .k-content .k-animation-container .k-child-animation-container > div
                    {
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                    }

                    .migrations-page-form .k-tabstrip .k-content .k-animation-container .k-child-animation-container > div > .raw-data-grid-container
                    {
                        flex: 1;
                        overflow-y: hidden;
                    }

                    .migrations-page-form .k-tabstrip .k-content
                    { 
                        padding: 6px 0 0 0;/*12px 16px 8px 16px;*/
                        overflow: hidden;
                        border: none;
                    }

                    .migrations-page-form .k-tabstrip .k-tabstrip-items-wrapper,
                    .migrations-page-form .k-tabstrip .k-tabstrip-items-wrapper .k-tabstrip-items
                    {
                        border: none;
                    }

                    .migrations-page-form .k-tabstrip .k-tabstrip-items-wrapper .k-tabstrip-items .k-item
                    {
                        color: ${currentTheme.bodyText};
                        border: none;
                        text-align: left;
                    }

                    .migrations-page-form .k-tabstrip .k-tabstrip-items-wrapper .k-tabstrip-items .k-item.k-active
                    {
                        font-weight: 700;
                        font-size: 15px;
                    }

                    .migrations-page-form .k-tabstrip .k-tabstrip-items-wrapper .k-tabstrip-items .k-item span
                    {
                        padding-left: 2px;
                    }

                    /* subscriptions grid */
                    .migrations-page-form .migration-subscriptions-grid
                    {
                        
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-grid-header,
                    .migrations-page-form .migration-subscriptions-grid .k-grid-header thead > tr
                    {
                        /*background: transparent;*/
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-filtercell input,
                    .migrations-page-form .migration-history-grid .k-filtercell input
                    {
                        padding: 4px 6px;
                    }

                    .migrations-page-form .migration-subscriptions-grid,
                    .migrations-page-form .migration-history-grid
                    {
                        height: 100%;                        
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-grid-header col:nth-of-type(1),
                    .migrations-page-form .migration-history-grid .k-grid-header col:nth-of-type(1)
                    {
                        width: 7%;                        
                    }
                    .migrations-page-form .migration-subscriptions-grid .k-grid-table col:nth-of-type(1),
                    .migrations-page-form .migration-history-grid .k-grid-table col:nth-of-type(1)
                    {
                        width: 7%;
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-grid-header col:nth-of-type(2),
                    .migrations-page-form .migration-history-grid .k-grid-header col:nth-of-type(2)
                    {
                        width: 15%;
                    }
                    .migrations-page-form .migration-subscriptions-grid .k-grid-table col:nth-of-type(2),
                    .migrations-page-form .migration-history-grid .k-grid-table col:nth-of-type(2)
                    {
                        width: 15%;
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-grid-header col:nth-of-type(3),
                    .migrations-page-form .migration-history-grid .k-grid-header col:nth-of-type(3)
                    {
                        width: 13%;
                    }
                    .migrations-page-form .migration-subscriptions-grid .k-grid-table col:nth-of-type(3),
                    .migrations-page-form .migration-history-grid .k-grid-table col:nth-of-type(3)
                    {
                        width: 13%;
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-grid-header col:nth-of-type(4),
                    .migrations-page-form .migration-history-grid .k-grid-header col:nth-of-type(4)
                    {
                        width: 13%;
                    }
                    .migrations-page-form .migration-subscriptions-grid .k-grid-table col:nth-of-type(4),
                    .migrations-page-form .migration-history-grid .k-grid-table col:nth-of-type(4)
                    {
                        width: 13%;
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-grid-header col:nth-of-type(5),
                    .migrations-page-form .migration-history-grid .k-grid-header col:nth-of-type(5)
                    {
                        width: 10%;
                    }
                    .migrations-page-form .migration-subscriptions-grid .k-grid-table col:nth-of-type(5),
                    .migrations-page-form .migration-history-grid .k-grid-table col:nth-of-type(5)
                    {
                        width: 10%;
                    }

                    .migrations-page-form .migration-subscriptions-grid .k-grid-header col:nth-of-type(6),
                    .migrations-page-form .migration-history-grid .k-grid-header col:nth-of-type(6)
                    {
                        width: 42%;
                    }
                    .migrations-page-form .migration-subscriptions-grid .k-grid-table col:nth-of-type(6),
                    .migrations-page-form .migration-history-grid .k-grid-table col:nth-of-type(6)
                    {
                        width: 42%;
                    }


                    .migrations-page-form .migration-subscriptions-grid .statusText,
                    .migrations-page-form .migration-subscriptions-grid .startedOnUTC,
                    .migrations-page-form .migration-subscriptions-grid .endedOnUTC,
                    .migrations-page-form .migration-subscriptions-grid .duration,
                    .migrations-page-form .migration-history-grid .statusText,
                    .migrations-page-form .migration-history-grid .startedOnUTC,
                    .migrations-page-form .migration-history-grid .endedOnUTC,
                    .migrations-page-form .migration-history-grid .duration
                    {
                        text-align: center;
                        justify-content: center;
                    }
                    /* subscriptions grid */
                `
            }
        </style>
    </Fragment>
  );
};